import { NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import {
  RouterStateSerializer,
  StoreRouterConnectingModule
} from '@ngrx/router-store';
import { environment } from 'environments/environment';
import { AppComponent } from '@app/app.component';
import { CustomRouterStateSerializer } from '@shared/utils/routerUtil';
import * as appV1 from '@app/v1_integration';
import { CoreModule } from '@core/core.module';
import { reducers, metaReducers } from '@store/reducers';
import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from '@app/app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { Router } from '@angular/router';
import { PlatformLocation, LocationChangeEvent } from '@angular/common';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    ToastrModule.forRoot({
      progressBar: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      timeOut: 3500,
      enableHtml: true
    }),
    AppRoutingModule,
    SharedModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreRouterConnectingModule.forRoot({
      /*
        They stateKey defines the name of the state used by the router-store reducer.
        This matches the key defined in the map of reducers
      */
      stateKey: 'router'
    }),
    /**
     * Store devtools instrument the store retaining past versions of state
     * and recalculating new states. This enables powerful time-travel
     * debugging.
     *
     * To use the debugger, install the Redux Devtools extension for either
     * Chrome or Firefox
     *
     * See: https://github.com/zalmoxisus/redux-devtools-extension
     */
    StoreDevtoolsModule.instrument({
      name: 'NgRx Zigzag-v2 DevTools',
      logOnly: environment.production
    }),
    EffectsModule.forRoot([])
  ],
  providers: [
    /**
     * The `RouterStateSnapshot` provided by the `Router` is a large complex structure.
     * A custom RouterStateSerializer is used to parse the `RouterStateSnapshot` provided
     * by `@ngrx/router-store` to include only the desired pieces of the snapshot.
     */
    { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer }
  ],
  declarations: [AppComponent],
  entryComponents: [AppComponent]
})
export class AppModule {
  constructor(
    private upgrade: UpgradeModule,
    public router: Router,
    private location: PlatformLocation
  ) {
    // console.log(`Is Production: ${environment.production}`);
    console.log(`environment.appRoot URL: ${environment.appRoot}`);
  }

  ngDoBootstrap() {
    this.upgrade.bootstrap(document.body, [appV1.APP_NAME], {
      strictDi: true
    });

    // Need to force routing to occur when the URL is changed (usually through back or forward button).
    this.location.onPopState((e: LocationChangeEvent) => {
      this.forceTriggerRouting();
    });
  }

  /**
   *
   */
  forceTriggerRouting() {
    const routeUrl = window.location.hash.slice(1); // Removes the "#" from string to get route.
    this.router.navigateByUrl(routeUrl);
  }
}
